var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inventoryProductsCategoriesForm',{attrs:{"typeEndPoint":'inventoryProductsCategoriesShow',"dataParams":this.$route.params}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bd0af20","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/papeleria/products/categories/edit.vue
// module id = null
// module chunks = 